<template>
    <div class="flex h-100">
        <router-link to="/" class="ph3 flex items-center pointer">
            <img src="@/assets/img/logos/tooliaba_logo.svg">
        </router-link>
        <HeaderDropdown :menuVisible="searchMenu" @menuChanged="searchMenu = $event; onMenuChanged()" :align-left='false' :position-relative='false' class="ml-auto">
            <template slot="item">
                <img style="width:22px;" src="@/assets/img/icon_search_black.svg" v-if="searchMenu">
                <img src="@/assets/img/icon_search_white.svg" v-if="!searchMenu">
            </template>
            <template slot="menu">
                <NavSearch />
            </template>
        </HeaderDropdown>
        <HeaderDropdown :menuVisible="mainMenu" @menuChanged="mainMenu = $event; onMenuChanged()" :align-left='false' :position-relative='false'>
            <template slot="item">
                <img src="@/assets/img/icon_x.svg" v-if="mainMenu">
                <img src="@/assets/img/icon_menu.svg" v-if="!mainMenu">
            </template>
            <template slot="menu">
                <MobileAuthenticatedMenu v-if="$auth.check()" />
                <MobileMainMenu v-else />
            </template>
        </HeaderDropdown>
    </div>
</template>

<script>
import HeaderDropdown from '@/components/header/HeaderDropdown.vue';
import MobileAuthenticatedMenu from '@/components/header/nav-items/MobileAuthenticatedMenu.vue';
import MobileMainMenu from '@/components/header/nav-items/MobileMainMenu.vue';
import NavSearch from '@/components/global/NavSearch.vue';
import { mapState } from 'vuex';

export default {
    components: {
        HeaderDropdown,
        MobileAuthenticatedMenu,
        MobileMainMenu,
        NavSearch
    },
    data() {
        return {
            searchMenu: false,
            mainMenu: false
        };
    },
    computed: {
        ...mapState('users', ['user'])
    },
    watch: {
        user() {
            this.mainMenu = false;
            this.onMenuChanged();
        }
    },
    methods: {
        onMenuChanged() {
            this.$emit('showMenu', this.searchMenu || this.mainMenu);
        }
    },
    beforeDestroy() {
        this.$emit('showMenu', false);
    }
};
</script>
